import type { Campaign } from '~/modules/campaign/types';
import type { ICampaignIssue } from '~/modules/campaign';

import { useNotificationHandler } from './useNotificationHandler';
import { useCallback, useEffect, useState } from 'react';

export const useCampaignValidation = <T extends Campaign>() => {
  const { showNotification, hideNotification } = useNotificationHandler();
  const [campaignIssues, setCampaignIssues] = useState<ICampaignIssue[]>();

  const handleValidateCampaign = useCallback((campaignData?: T) => {
    if (!campaignData) return [];

    // const parsedParams = CampaignValidationSchema.safeParse(campaignData);
    // if (!parsedParams.success) {
    //   const campaignIssues: ICampaignIssue[] = parsedParams.error.issues.map((issue) => {
    //     return {
    //       key: issue.path?.[0]?.toString() || '',
    //       message: issue.message,
    //     };
    //   });
    //   return campaignIssues;
    // }

    return [];
  }, []);

  const handleRefetchCampaignIssues = (campaignData?: T) => {
    if (!campaignData) return;

    const issues = handleValidateCampaign(campaignData);
    setCampaignIssues(issues);
  };

  const handleResetCampaignIssues = useCallback(() => {
    setCampaignIssues([]);
  }, []);

  useEffect(() => {
    if (!campaignIssues?.length) {
      hideNotification();
      return;
    }

    showNotification(campaignIssues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignIssues]);

  return {
    campaignIssues,
    handleValidateCampaign,
    handleRefetchCampaignIssues,
    handleResetCampaignIssues,
  };
};
